export type DashboardTierAction =
    | 'einstallen'
    | 'ausstallen_extern'
    | 'umstallen_intern'
    | 'sammelstelle';

export interface DashboardTierActionOption {
    action: DashboardTierAction;
    title: string;
    description: string;
    icon: string;
}

export const DASHBOARD_TIER_ACTION_OPTIONS: DashboardTierActionOption[] = [
    {
        action: 'einstallen',
        title: 'Tiere einstallen',
        description: 'Tiere in eine Gruppe einstallen und an HIT melden.',
        icon: 'login',
    },
    {
        action: 'ausstallen_extern',
        title: 'Ausstallen',
        description: 'Verkauf an einen externen Betrieb (Ausstallliste anlegen).',
        icon: 'logout',
    },
    {
        action: 'umstallen_intern',
        title: 'Umstallen',
        description: 'Umstallen innerhalb Ihrer Betriebe (Transfer zwischen eigenen Betrieben).',
        icon: 'swap_horiz',
    },
    {
        action: 'sammelstelle',
        title: 'Sammelstelle',
        description: 'Pass/Ohrmarke scannen, prüfen und nächstes Tier – Sammelstelle-Flow.',
        icon: 'qr_code_scanner',
    },
];
